// extracted by mini-css-extract-plugin
export var actionButton = "_jr-t";
export var buttonContainer = "_jr-0";
export var buttonContainer2 = "_jr-1";
export var buttonSection = "_jr-2";
export var details = "_jr-3";
export var dropdownItem = "_jr-5";
export var dropdownItemsContainer = "_jr-4";
export var fileInput = "_jr-r";
export var headerButton = "_jr-6";
export var icon = "_jr-7";
export var input = "_jr-8";
export var macroListItem = "_jr-9";
export var mainContent = "_jr-a";
export var microText = "_jr-b";
export var modal = "_jr-w";
export var optionsButton = "_jr-c";
export var paperclip = "_jr-s";
export var pillContent = "_jr-d";
export var preview = "_jr-e";
export var preview2 = "_jr-f";
export var quillEditor = "_jr-q";
export var selectedMacro = "_jr-g";
export var sidebar = "_jr-h";
export var sidebarHeader = "_jr-j";
export var sidebarList = "_jr-i";
export var sidebarListItem = "_jr-k";
export var sidebarSearch = "_jr-l";
export var snoozeDurationWrapper = "_jr-v";
export var statusPillContainer = "_jr-m";
export var tagsContainer = "_jr-n";
export var unselectedMacro = "_jr-o";
export var variable = "_jr-u";
export var wrapper = "_jr-p";